import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as actions from '../actions/tools';
import Usergroup from '../components/Usergroup';

const filterSelector = (state, props) =>
  state.tools && state.tools[props.filter];

const usersSelector = (state, props) =>
  props.group.groupusers;

const filteredUsersSelector = createSelector(
  [filterSelector, usersSelector],
  (filter, users) => {
    if (filter === '') {
      return users;
    }
    return users.filter(user => {
        return user.name.replace(user.id, '').trim().toLowerCase().indexOf(filter.toLowerCase()) === 0
      },
    );
  },
);

const mapStateToProps = (state, props) => ({
  filteredUsers: filteredUsersSelector(state, props),
  selectedUser: state.tools.selectedUser,
  selectedGroup: state.tools.selectedGroup,
});

const mapDispatchToProps = dispatch => ({
  onSelectUser: (user, group) => dispatch(actions.selectUser(user, group, true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Usergroup);



// WEBPACK FOOTER //
// ./src/containers/Usergroup.js